import React, { useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';

import FeedItem from 'components/LeftMenu/Shared/FeedItem';

import { getUrl } from 'utils/url';
import FeedIcon from 'components/Shared/Common/FeedIcon';

const MulticastFeedItem = ({
    id,
    isMuted = false,
    onMute = () => {},
    _currentFeed,
    onEdit,
    name,
    color,
    unreadCount,
    isAdmin = false
}) => {
    const handleEditItem = useCallback(() => onEdit(id), [onEdit, id]);

    const renderItemIcon = useMemo(() => (
        <FeedIcon
            name={name}
            size="xs"
            color={color}
        />
    ), [name, color]);

    const isCurrent = id === _currentFeed;
    const handleMute = useCallback((isSoundEnabled) => onMute(id, isSoundEnabled), [id])

    return (
        <>
            {(isCurrent && color)
                && (
                    <span
                        style={{ backgroundColor: color }}
                        className="border"
                    />
                )}
            <FeedItem
                isMuted={isMuted}
                onMute={handleMute}
                onEdit={isAdmin ? handleEditItem : undefined}
                iconRender={renderItemIcon}
                label={name}
                href={getUrl('feed', { _feed: id })}
                unreadCount={unreadCount}
                isCurrent={isCurrent}
            />
        </>
    );
}

MulticastFeedItem.propTypes = {
    name: PropTypes.string,
    isMuted: PropTypes.bool,
    isAdmin: PropTypes.bool,
    onMute: PropTypes.func,
    _currentFeed: PropTypes.string,
    onEdit: PropTypes.func.isRequired,
    color: PropTypes.string.isRequired,
    unreadCount: PropTypes.number
};

export default injectIntl(MulticastFeedItem);
